// views/AiToolsLanding.jsx
import { Depths, FontIcon, Stack, Text, mergeStyleSets } from '@fluentui/react';
import { useRouteMatch } from 'react-router-dom';

const tiles = [
  {
    key: 'bio-builder',
    title: 'Bio Builder',
    description: 'Generate tailored project- and proposal-specific bios for your team.',
    route: 'bio-builder',
  },
  {
    key: 'workplan-builder',
    title: 'Proposal Builder',
    description: 'Draft structured proposals with milestones, tasks, and timelines.',
    route: 'workplan-builder',
  },
  {
    key: 'vector-stores',
    title: 'Vector Stores',
    description: 'Manage your vector stores and uploaded files.',
    route: 'vector-stores',
  }
];

const classes = mergeStyleSets({
  root: {
    padding: 24,
    maxWidth: 1200,
    margin: '24px auto'
  },
  header: {
    maxWidth: 700,
  },
  tilesContainer: {
    marginTop: 16,
  },
  tileLink: {
    textDecoration: 'none',
  },
  tile: {
    width: 260,
    minHeight: 150,
    padding: 16,
    borderRadius: 8,
    border: '1px solid rgba(0,0,0,0.1)',
    boxShadow: Depths.depth8,
    background: 'white',
    textDecoration: 'none',
    cursor: 'pointer',
    selectors: {
      '&:hover': {
        boxShadow: Depths.depth16,
        transform: 'translateY(-2px)',
      },
    },
    transition: 'box-shadow 0.1s ease, transform 0.1s ease',
  },
  tileFooter: {
    marginTop: 12,
    opacity: 0.8,
  },
});

const AiToolsLanding = (props) => {
  const { url } = useRouteMatch();

  return (
    <Stack className={classes.root} tokens={{ childrenGap: 24 }}>
      {/* Header */}
      <Stack className={classes.header} tokens={{ childrenGap: 8 }}>
        <Text variant="xxLarge">
          <FontIcon iconName='ChatBot' style={{marginRight: 8}} />
          AI Tools
        </Text>
        <Text variant="small">
          A collection of AI-powered helpers to speed up your bios, workplans, and proposal
          writing.
        </Text>
      </Stack>

      {/* Tiles */}
      <Stack
        horizontal
        wrap
        tokens={{ childrenGap: 16 }}
        className={classes.tilesContainer}
      >
        {tiles.map((tile) => (
          <div
            key={tile.key}
            onClick={() => props.history.push(`${url}/${tile.route}`)}
            className={classes.tileLink}
          >
            <Stack className={classes.tile} tokens={{ childrenGap: 8 }}>
              <Text variant="xLarge">
                {tile.title}
              </Text>
              <Text variant="smallPlus">{tile.description}</Text>
              <Text variant="small" className={classes.tileFooter}>
                Open {tile.title} <FontIcon iconName='Forward' />
              </Text>
            </Stack>
          </div>
        ))}
      </Stack>
    </Stack>
  );
};

export default AiToolsLanding;
